import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const resourceImporterSelectors = importerSelectors(
  'resource.importer',
);

export default resourceImporterSelectors;
